interface RequestParams {
	[key: string]: string
}

export const mainMediaMobile = "(max-width: 1024px)";

export const parseSearchQuery = (searchString: string): RequestParams => {
	const result: RequestParams = {};
	const entriesIterator = new URLSearchParams(searchString).entries();
	const entries = Array.from(entriesIterator);

	entries.forEach((param) => {
			result[param[0]] = param[1];
		}
	);

	return result;
};


export const scrollToTopCalculator = (extraCheck: boolean = true) => {

	const yOffset = -200;
	const element = document.querySelector<HTMLDivElement>('.refinance-calculator');
	if (element && extraCheck) {
		const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
		window.scrollTo({top: y, behavior: 'smooth'});
	}
}
